import { useRef } from "react";
import ModalPop from "./ModalPop";

interface ServiceItem {
  title: string;
  description: string;
}

const services: ServiceItem[] = [
  {
    title: "유품정리",
    description: "고인의 유품을 정리하고\n필요한 물품을 분류합니다.",
  },
  {
    title: "빈집정리",
    description: "장기간 비어 있던 주택을\n깨끗하게 정리합니다.",
  },
  { title: "특수청소", description: "오염된 공간을\n전문 장비로 복원합니다." },
  {
    title: "쓰레기집청소",
    description: "쌓인 생활쓰레기를\n신속하게 정리합니다.",
  },
  {
    title: "상가·점포철거",
    description: "폐업진행 중인 혹은 진행한\n상가·점포를 철거합니다",
  },
  { title: "이민·이사정리", description: "이주 전 불필요한 짐을\n정리합니다." },
  {
    title: "고독사 청소",
    description: "현장 소독과 탈취,\n복구를 진행합니다.",
  },
  {
    title: "폐기물처리",
    description: "각종 폐기물을 안전하게\n수거 처리합니다.",
  },
];

const Service = () => {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };
  return (
    <div
      id="services"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36 text-center lg:text-left"
    >
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div className="mx-auto max-w-[1200px] ">
        {/* Heading */}
        <div className="text-center">
          <p className="text-lg lg:text-xl">어떤 서비스들을 받아볼 수 있나요?</p>
          <h2 className="mt-2 text-3xl md:text-4xl xl:text-5xl">
            <span className="font-light">바우하우스</span> <span className="text-[#F4791C]">서비스 목록</span>
          </h2>
        </div>

        {/* Card grid */}
        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 md:mt-10 md:grid-cols-4">
          {services.map((service) => (
            <div key={service.title} data-aos="fade-up" className="flex flex-col rounded-2xl bg-[#feefc5] p-5">
              <h3 className="gbold text-black">{service.title}</h3>
              <p className="mt-2 flex-1 whitespace-pre-line text-base leading-tight tracking-tighter">
                {service.description}
              </p>
              <div className="mt-4 flex flex-col gap-2">
                <button
                  type="button"
                  onClick={() => window.open("https://blog.naver.com/PostList.naver?blogId=ansgo13&from=postList&categoryNo=1")}
                  className="w-full rounded-md bg-[#F4791C] py-1.5 text-base text-white transition-colors hover:bg-[#e0690f]"
                >
                  작업사례 보러가기
                </button>
                <button
                  type="button"
                  onClick={openfunc}
                  className="w-full rounded-md bg-gray-900 py-1.5 text-base text-white transition-colors hover:bg-gray-800"
                >
                  견적문의 요청하기
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Service;
